export default __webpack_public_path__ + "static/media/agliveLogo.e937721f.png";